(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["services-grid"] && !Shopify.designMode) return;
  try {
    
  /* Lazy-load video: só carrega src + dá play quando o card entra na viewport */
  (function() {
    if (typeof IntersectionObserver === 'undefined') return;
    const videos = document.querySelectorAll('.services-grid__video[data-src]');
    if (!videos.length) return;
    const io = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        const v = entry.target;
        if (!v.src && v.dataset.src) {
          v.src = v.dataset.src;
          v.load();
          v.play().catch(() => {});
        }
        io.unobserve(v);
      });
    }, { rootMargin: '200px 0px' });
    videos.forEach(v => io.observe(v));
  })();

  } catch(e) { console.error(e); }
})();
})();
